module.exports = __webpack_public_path__ + "img/logoConsumerBranca.5bf0c485.png";